import React from 'react';
import { Loader } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface LoadingProps {
  message?: string;
  size?: number | string;
  fullHeight?: boolean;
}

const Loading: React.FC<LoadingProps> = ({
  message,
  size = 'lg',
  fullHeight = false,
}) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: fullHeight ? '100%' : 'auto',
        minHeight: fullHeight ? '200px' : undefined,
        width: '100%',
        gap: 16,
      }}
    >
      <Loader size={size} />
      <span style={{ marginTop: 8, color: '#888', fontSize: 16 }}>
        {message || t('common.loading') || 'Carregando...'}
      </span>
    </div>
  );
};

export default Loading;
